import React from "react";
import PropTypes from "prop-types";

const ListItem = (props) => {

    return  <a href={props.url}>
                <div className="neoListItem">
                    <h3 className="title">{props.name} 
                        <span className="seeAllItems">
                        <i className="ion-ios-arrow-forward"/>
                        </span>
                    </h3>
                </div>  
            </a>

}

ListItem.propTypes = {
    name: PropTypes.string
}

export default ListItem;